<template>
  <div class="queue-btn-container">
    <el-badge :value="aggregatedQueueCount || ''">
      <div class="no-border">
        <modal-opener
          :id="modalId"
          :title="$i18n.t('queue_list')"
          size="small"
          :disabled="!aggregatedQueueCount"
          export-class="is-plain"
        >
          <span class="material-icons md-18">schedule</span>
        </modal-opener>
      </div>
    </el-badge>
    <modal :id="modalId" :title="$i18n.t('queue_list')" size="70%">
      <process-queue-list v-if="processQueueCount" :search-data="searchData" :extra-options="extraOptions" />
      <import-queue-list v-if="importQueueCount" :importId="getCollectionOrId" />
    </modal>
  </div>
</template>

<script>
/**
 * @param QueueModal component
 *
 * @description Queue típúsú processzek megjelenítése adott entitáshoz egy modalban
 */
import { get } from 'lodash'
import { mapActions } from 'vuex'
import ModalOpener from '../../modal/Opener'
import hamburgerMixin from './mixin-hamburger'
import notify from '../../../utils/mixin-notify'
import ImportQueueList from '../../process-list/ImportQueueList'
import ProcessQueueList from '../../process-list/ProcessQueueList'

const TASK_STATUS_PROCESSING = 'processing'

export default {
  name: 'QueueModal',
  mixins: [notify, hamburgerMixin],
  components: {
    ModalOpener,
    ProcessQueueList,
    ImportQueueList,
    Modal: () => import('../../modal/Modal'),
  },
  props: [],
  data() {
    return {
      intervalId: null,
      processQueueCount: 0,
      importQueueCount: 0,
      listId: '',
      modalId: 'queue-modal',
      extraOptions: {
        showLockColumn: false,
        showPageLimiter: true,
        showPagination: true,
        showActionButtons: false,
        showColumnSelector: false,
        showSelectionColumn: false,
        showImportButtons: false,
        showQueueActionsButton: false,
      },
    }
  },
  computed: {
    getCollectionOrId() {
      return this.mongoList ? get(this.mongoList, 'collection', '').toLowerCase() : this.queryId || this.mongoId || null
    },
    mongoList() {
      return this.$get('mongoList')
    },
    queryId() {
      return this.$get('queryId')
    },
    searchData() {
      return { listId: this.listId }
    },
    aggregatedQueueCount() {
      return this.processQueueCount + this.importQueueCount
    },
    showImportButtons() {
      return this.visibilityState({ key: 'showImportButtons' })
    },
    showQueueActionsButton() {
      return this.visibilityState({ key: 'showQueueActionsButton' })
    },
    showQueueProgressButton() {
      return this.visibilityState({ key: 'showQueueActionsButton' }) || this.showImportButtons
    },
  },
  methods: {
    ...mapActions(['hideModal']),
    async refreshQueueCount() {
      if (this.showQueueActionsButton) await this.getProcessQueueInfo()
      if (this.showImportButtons) await this.getImportQueueInfo()
    },
    getPercentage(task) {
      const progressCount = task.processed + task.failed
      return progressCount ? (progressCount / task.rows) * 100 : 0
    },
    async getImportQueueInfo() {
      try {
        this.importQueueCount = get(
          await this.$client.execute({
            operationId: 'Dynform_importProgress',
            parameters: {
              importId: this.getCollectionOrId,
            },
          }),
          'body',
          [],
        ).length
      } catch (error) {
        console.error(error)
      }
    },
    async getProcessQueueInfo() {
      const filter = {
        listId: this.listId,
        status: TASK_STATUS_PROCESSING,
      }
      const result = (
        await this.$client.execute({
          operationId: 'ProcessQueue_get',
          parameters: { search: JSON.stringify(filter) },
        })
      ).body

      this.processQueueCount = get(result, 'meta.itemCount', 0)
    },
  },
  beforeDestroy() {
    clearInterval(this.intervalId)
  },
  mounted() {
    const queuePollInterval = get(window, 'CORE.env.queuePollInterval', 1000)
    this.intervalId = setInterval(this.refreshQueueCount, queuePollInterval)
    window.CORE.intervalTimers.push(this.intervalId)
    this.listId = this.getCollectionOrId
    if (!this.listId) return

    this.refreshQueueCount()
  },
}
</script>

<style lang="scss" scoped>
.no-border {
  button.el-button {
    border: none;
  }
}
.el-badge [disabled] span {
  color: $light3;
}
.el-input__inner {
  min-width: unset;
}
</style>
